import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import classNames from "classnames";

import { CModal } from "@coreui/react";

import { CButton } from "../../controls";

import placeholder from "./placeholder600x400.svg";

export const CFileItem = ({ file, clickable = true, className, ...props }) => {
  const previewRef = useRef(null);
  return clickable ? (
    <>
      <span
        onClick={() => previewRef.current?.open()}
        className={classNames(
          "text-[#17BD08] cursor-pointer text-ellipsis overflow-hidden whitespace-nowrap font-medium no-underline hover:underline hover:text-[#008939]",
          className
        )}
        {...props}
      >
        {file?.original_name}
      </span>
      <ImagePreview imageData={file} ref={previewRef} />
      {/* <a
        href={file?.path}
        target="_blank"
        rel="noopener noreferrer"
        className={classNames(
          "text-[#17BD08] text-ellipsis overflow-hidden whitespace-nowrap font-medium no-underline hover:underline hover:text-[#008939]",
          className
        )}
        {...props}
      >
        {file?.original_name}
      </a> */}
    </>
  ) : (
    <p {...props}>{file?.original_name}</p>
  );
};

export const ImagePreview = forwardRef(({ imageData }, ref) => {
  //#region Data
  const [open, setOpen] = useState(false);
  const [imgSrc, setImgSrc] = useState(imageData?.path ?? "");
  //#endregion

  //#region Event
  const onClose = () => setOpen(false);
  //#endregion

  useImperativeHandle(ref, () => ({
    open: () => setOpen(true),
  }));

  //#region Render
  return (
    <CModal show={open} onClose={onClose} centered closeOnBackdrop={false}>
      <div className="flex flex-col p-3 items-center justify-center max-w-[800px]">
        <img
          src={imgSrc}
          alt={imageData?.original_name}
          onError={() => setImgSrc(placeholder)}
          className="max-w-full h-auto object-cover"
        />
        <div className="flex justify-center mt-4">
          <CButton onClick={onClose}>Đóng</CButton>
        </div>
      </div>
    </CModal>
  );
  //#endregion
});
